// extracted by mini-css-extract-plugin
module.exports = {"selectContainer":"styles_selectContainer__1CHyz","selectLabel":"styles_selectLabel__3gSHI","select":"styles_select__2z3jB","error":"styles_error__2QP4s"};